import React from 'react';
import T from 'prop-types';
import cx from 'classnames';

import Tooltip from '../../../../components/Tooltip';

const AdvancedChartLegend = ({
  items,
  activeItem,
  className,
  onClick,
  onMouseOver,
  onMouseOut,
}) => (
  <div className={cx('advanced-chart-legend', className)}>
    {items.map(({ id, name, color, tooltipContent }) => (
      <Tooltip
        key={id}
        content={tooltipContent}
        placement="top"
        colorVariant="light"
        overlayClassName="advanced-chart-legend-item-tooltip"
      >
        <div
          className={cx('advanced-chart-legend__item', {
            'advanced-chart-legend__item--active': activeItem && id === activeItem,
            'advanced-chart-legend__item--inactive': activeItem && id !== activeItem,
          })}
          role="button"
          tabIndex={0}
          onClick={() => onClick({ id })}
          onMouseOver={() => onMouseOver({ id })}
          onFocus={() => onMouseOver({ id })}
          onMouseOut={() => onMouseOut({ id })}
          onBlur={() => onMouseOut({ id })}
        >
          <span
            className="advanced-chart-legend__item--marker"
            style={{ backgroundColor: color }}
          />
          <span className="advanced-chart-legend__item--name">{name}</span>
        </div>
      </Tooltip>
    ))}
  </div>
);

AdvancedChartLegend.propTypes = {
  items: T.arrayOf(
    T.shape({
      id: T.string,
      name: T.node,
      color: T.string,
      tooltipContent: T.node,
    })
  ).isRequired,
  className: T.string,
  activeItem: T.string,
  onClick: T.func.isRequired,
  onMouseOver: T.func.isRequired,
  onMouseOut: T.func.isRequired,
};

export default AdvancedChartLegend;
